<template>
  <div class="container page-py">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info flex"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/help-center"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('dreamFlatHelpCenter') }} </nuxt-link
        ><span class="navigate-info-arrow">></span
        ><span class="navigate-info-span" itemprop="name">{{
          $t('hsDreamFlatTitle')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <div class="content-wrapper">
      <div class="content">
        <h1>
          {{ $t('contentCreationAndProjectDemonstration') }}
        </h1>
        <LazyHelpCenterSectionsCreateContentDemonstration />
      </div>
      <HelpCenterSideMenu />
    </div>
    <div class="transition-article">
      <ui-link
        :to="`/help-center/creating-project?article=howToSwitch`"
        class="transition-article__left"
      >
        <div class="btn">
          <SvgBtnArrowSvg
            color="var(--var-black-200)"
            :right="locale === 'ar'"
          />{{ $t('back') }}
        </div>
        <div class="title">
          {{ $t('createProject') }}
        </div>
      </ui-link>
      <ui-link class="transition-article__right"> </ui-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useHead} from '#imports';
import {useI18n} from 'vue-i18n';

const {t, locale} = useI18n();
useHead({
  title: `${t('aboutDreamFlat')}`,
  meta: [
    {
      name: 'description',
      content: `${t('aboutDfMetaDesc')}`,
    },
  ],
});
useSeoMeta({
  ogTitle: `${t('aboutDreamFlat')}`,
  description: `${t('aboutDfMetaDesc')}`,
  ogDescription: `${t('aboutDfMetaDesc')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
});
</script>

<style scoped lang="scss">
@import 'css/help-center/help-center-general-ctyle';
.transition-article {
  max-width: calc(100% - 340px);
  display: flex;
  justify-content: space-between;
  gap: $g-5;
  border: 0px;
  &__left {
    width: 100%;
    margin-bottom: $m-10;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: $p-3 $p-8;
    border: 1px solid var(--var-white-400);
    border-radius: $br-3;
    gap: $g-2;
    .title {
      @include title-fs-18-fw-600-white-000;
      color: var(--var-blue-100);
    }
    .btn {
      cursor: pointer;
      @include title-fs-14-fw-600-gray-100;
      color: var(--var-black-200);
      display: flex;
      align-items: center;

      svg {
        height: 24px;
        margin-left: -10px;
      }
    }
  }
  &__right {
    width: 100%;
    margin-bottom: $m-10;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: $p-3 $p-8;
    border-radius: $br-3;
    gap: $g-2;
  }
  @media (max-width: $lg) {
    max-width: calc(100%);
  }

  @media (max-width: 500px) {
    flex-direction: column;
    &__left {
      margin-bottom: $m-3;
      align-items: center;
      padding-right: 0px;
    }
    &__right {
      align-items: center;
      padding-left: 0px;
    }
    svg {
      display: none;
    }
  }
}

@media (max-width: $lg) {
  .main-info {
    width: 100%;
  }
  .table-contents {
    width: 100%;
  }
}
</style>
